// GENERATED by `npm run api:generate` from openapi/operator.json. Do not edit by hand.
import createClient from 'openapi-fetch';
/** The only way the operator console talks to the API (ADR-033). */
export function createOperatorClient(options = {}) {
    return createClient(options);
}
//# sourceMappingURL=index.js.map